import { createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "booking-pattern-selector" }
const _hoisted_2 = { class: "form-check-container" }
const _hoisted_3 = { class: "form-check form-check-inline" }
const _hoisted_4 = ["checked"]
const _hoisted_5 = {
  key: 0,
  class: "form-check form-check-inline"
}
const _hoisted_6 = ["checked"]

import { computed } from "vue";
import { useMasterDataHelpers } from "../composables/useMasterDataHelpers";


export default {
  __name: 'BookingPatternSelector',
  props: {
	form: {
		type: Object,
		required: true,
	},
	mode: {
		type: String,
		default: "create",
	},
},
  setup(__props) {

const props = __props;

const masterData = useMasterDataHelpers();

function setBookingPattern(pattern) {
	try {
		if (pattern === "single") {
			// Clear series-related fields for single booking
			if (props.form?.setFieldValue) {
				props.form.setFieldValue("rrulePattern", "");
				props.form.setFieldValue("cancelledDates", []);
			}
		} else if (pattern === "series") {
			// Set a default pattern for series booking
			// This will be overridden by RecurrenceSelector
			if (props.form?.setFieldValue) {
				props.form.setFieldValue("rrulePattern", "FREQ=WEEKLY;COUNT=1");
			}
		}
	} catch (error) {
		console.warn("Failed to set booking pattern:", error);
	}
}

// Extract form for template
const { form } = props;

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("label", { class: "form-label" }, "Buchungsmuster", -1 /* CACHED */)),
    _createCommentVNode(" Use TanStack Form Subscribe for reactive UI "),
    _createVNode(_unref(form).Subscribe, null, {
      default: _withCtx(({ values }) => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("input", {
              id: "singleBooking",
              checked: !values.rrulePattern,
              type: "radio",
              name: "bookingPattern",
              value: "single",
              class: "form-check-input",
              onChange: _cache[0] || (_cache[0] = () => setBookingPattern('single'))
            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_4),
            _cache[2] || (_cache[2] = _createElementVNode("label", {
              for: "singleBooking",
              class: "form-check-label"
            }, " Einzelbuchung ", -1 /* CACHED */))
          ]),
          (_unref(masterData).canCreateSeries.value && __props.mode !== 'edit-instance')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("input", {
                  id: "seriesBooking",
                  checked: !!values.rrulePattern,
                  type: "radio",
                  name: "bookingPattern",
                  value: "series",
                  class: "form-check-input",
                  onChange: _cache[1] || (_cache[1] = () => setBookingPattern('series'))
                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_6),
                _cache[3] || (_cache[3] = _createElementVNode("label", {
                  for: "seriesBooking",
                  class: "form-check-label"
                }, " Serienbuchung ", -1 /* CACHED */))
              ]))
            : _createCommentVNode("v-if", true)
        ])
      ]),
      _: 1 /* STABLE */
    })
  ]))
}
}

}